module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_03@2x-e37d19fb4b4a3f0948b6db5d30c4ad5d.webp";